import React from 'react';
import medicalTeam from '../../assets/images/medical-team.png';

interface EndorsementSectionProps {
  onSignInClick: () => void;
}

const EndorsementSection: React.FC<EndorsementSectionProps> = ({ onSignInClick }) => {
  return (
    <div
      className="relative w-full bg-[#f8f6f2] py-12 md:py-16 lg:py-20"
      data-name="Endorsement Section"
      id="node-12_9724"
    >
      <div className="max-w-[1440px] mx-auto px-4 md:px-8 lg:px-16 xl:px-20 flex flex-col lg:flex-row items-center justify-between gap-8 lg:gap-12 xl:gap-16">
        <div
          className="flex flex-col gap-6 md:gap-8 w-full lg:max-w-[500px] xl:max-w-[569px] order-2 lg:order-1"
          data-name="Endorsement Text"
          id="node-12_9727"
        >
          <div
            className="font-['Ovo',_serif] text-[#1f1f1f] text-[28px] sm:text-[32px] md:text-[40px] lg:text-[44px] xl:text-[48px] uppercase text-center lg:text-left"
            id="node-12_9728"
          >
            <p className="block leading-[normal]">Endorse Excellence</p>
          </div>
          <div
            className="flex flex-col gap-10"
            data-name="Endorsement Description"
            id="node-12_9729"
          >
            <div
              className="font-['Ovo',_serif] font-normal text-[#1f1f1f] text-[16px] sm:text-[18px] md:text-[20px] lg:text-[22px] xl:text-[24px] text-center lg:text-left"
              id="node-12_9730"
              style={{ fontVariationSettings: "'wdth' 100" }}
            >
              <p className="block leading-relaxed">
                Once certified, connect with others in your network and earn endorsements to
                increase your CLOUT Score. Get endorsed, build your CLOUT.
              </p>
            </div>
            <button
              className="relative inline-flex items-center justify-center px-6 py-3 min-h-[48px] border-2 border-[#1f1f1f] hover:bg-[#1f1f1f] transition-all duration-200 cursor-pointer group self-center lg:self-start w-full sm:w-auto max-w-xs"
              data-name="Button"
              id="node-12_9731"
              onClick={onSignInClick}
            >
              <span
                className="font-['Ovo',_serif] text-[16px] sm:text-[18px] md:text-[20px] text-[#1f1f1f] uppercase group-hover:text-white transition-colors"
                id="node-I12_9731-315_4669"
              >
                Endorse Others
              </span>
            </button>
          </div>
        </div>
        <div className="w-full lg:w-[50%] xl:w-[45%] order-1 lg:order-2">
          <div className="relative w-full aspect-square max-w-[500px] lg:max-w-none mx-auto rounded-lg overflow-hidden shadow-lg">
            <img
              src={medicalTeam}
              alt="Medical team collaboration - building professional networks and endorsements"
              className="w-full h-full object-cover object-center"
              loading="lazy"
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.style.display = 'none';
                console.warn('Failed to load medical team image');
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EndorsementSection;
